import * as React from "react";
import { observer } from "mobx-react";
import { UitkSelect } from "uitk-react-select";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { Child, Infant, AgeOption } from "../typings";
import { UitkSpacing } from "uitk-react-spacing";
import { useLocalization } from "@shared-ui/localization-context";

export interface AgeSelectProps {
  ageOptions: AgeOption[];
  children: Child[] | Infant[];
  dataTestid?: string;
  id: string;
  labelKey: string;
  menuIndex: number;
  onChange: (roomIndex: number, infantIndex: number) => (event: React.ChangeEvent<HTMLSelectElement>) => void;
  padding: {};
}

export const AgeSelect = observer(
  ({ onChange, id, labelKey, dataTestid, children, ageOptions, padding, menuIndex }: AgeSelectProps) => {
    const { formatText } = useLocalization();

    const onChangeAgeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
      const index = +event.currentTarget.id.slice(-1);
      onChange(menuIndex, index)(event);
    };

    return (
      <div>
        <UitkSpacing padding={padding}>
          <UitkLayoutGrid columns={2} space="two" data-testid={dataTestid}>
            {children.map((child: Child | Infant, index: number) => {
              const label = formatText(labelKey, index + 1);
              const selectId = `${id}-${menuIndex}-${index}`;
              const validId = isNaN(+selectId.slice(-1)) ? `${index}` : selectId;

              return (
                <UitkLayoutGridItem colSpan={1} key={index}>
                  <UitkSelect label={label} value={child.age.toString()} onChange={onChangeAgeSelect} id={validId}>
                    {ageOptions.map((option: AgeOption) => (
                      <option key={option.value} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </UitkSelect>
                </UitkLayoutGridItem>
              );
            })}
          </UitkLayoutGrid>
        </UitkSpacing>
      </div>
    );
  }
);
